import kioskSurveyForm from "./kiosk";
import kitchenSurveyForm from "./kitchen";
import kitchenCumDiningSurveyForm from "./kitchen_cum_dining";

export const surveyForms = {
  kiosk: kioskSurveyForm,
  kitchen: kitchenSurveyForm,
  "kitchen-cum-dining": kitchenCumDiningSurveyForm,
};

export const getSurveyTypeSlug = (canteenType = "") => {
  const normalizedType = String(canteenType).trim().toLowerCase();

  if (normalizedType === "1") return "kiosk";
  if (normalizedType === "2") return "kitchen";
  if (normalizedType === "3") return "kitchen-cum-dining";

  if (normalizedType.includes("kiosk")) return "kiosk";
  if (normalizedType.includes("dining")) return "kitchen-cum-dining";
  if (normalizedType.includes("kitchen")) return "kitchen";

  return "";
};
